import axiosTokenInstance from 'services/api/backoffice';
import {
  IPB_DIRECTORY_MODERATION_DETAIL,
  IPB_DIRECTORY_MODERATION_DETAIL_ERROR,
} from '_models/redux/types';

// Action function
export const ipbDirectoryModerationDetailgAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/ipb/directory-stores/moderations/pendings/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: IPB_DIRECTORY_MODERATION_DETAIL,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: IPB_DIRECTORY_MODERATION_DETAIL_ERROR,
      response: e || {},
    });
  }
};
